import { SearchOutlined } from '@ant-design/icons';
import { Row, Col, Input, Button, Table } from "antd"
import { useEffect, useState } from "react"
import { timKiemDSNhanVien } from '../../services/nhanvien';
import AccountTable from './AccountTable';
import DonViSelectTree from '../../pages/utils/DonViSelectTree';
import Column from 'antd/es/table/Column';
import { TimKiemNhanVienRequest } from '@app/models/nhanvien/NhanVien';

const SearchAccountTable = ({ onChange }: { onChange: (account: any) => any }) => {
    const [idDonVi, setIdDonVi] = useState<number>(0);
    const [searchKey, setSearchKey] = useState<any>("");
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [dataTable, setDataTable] = useState<Array<any>>([]);
    const [expandedRowKey, setExpandedRowKey] = useState<string>("");
    const [accountSelected, setAccountSelected] = useState<any>();

    const timkiem = async () => {
        try {
            setIsLoadingTable(true);
            
            var rq = new TimKiemNhanVienRequest;
            rq.idDonVi = idDonVi;
            rq.tuKhoa = searchKey;
            const temp = await timKiemDSNhanVien(rq, 0, 0);
            var data = (temp?.data || []).map((item: any) => { item.key = item.id; return item });
            setDataTable(data);
        }
        catch (error: any) {
        };

        setIsLoadingTable(false);
    }

    const onSelectAccount = (accountSelected: any) => {
        setAccountSelected(accountSelected);
        onChange(accountSelected);
    }

    useEffect(() => {
        timkiem();
    }, []);

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            timkiem();
        }
    };
    return (
        <>
            <Row className="form-group" gutter={6}>
                <Col span={10} >
                    <DonViSelectTree donViQuanLy onChange={(e) => { setIdDonVi(e.target.value); }} />
                </Col>
                <Col span={10} >
                    <Input prefix={<SearchOutlined rev="" />} placeholder="Nhập tên, mã nhân viên, email, số điện thoại" onChange={(e) => { setSearchKey(e.target.value) }}
                        onKeyPress={handleKeyPress} />
                </Col>
                <Button type="primary" icon={<SearchOutlined rev="" />}
                    onClick={() => timkiem()}
                >
                    Tìm kiếm
                </Button>
            </Row>
            <Row>
                <Col span={24}>
                    <div className="card">
                        <div className="card-primary">
                            <Table
                                dataSource={dataTable}
                                loading={isLoadingTable}
                                locale={{ emptyText: "Không có dữ liệu" }}
                                expandable={{
                                    expandedRowRender: (record) => <AccountTable idNhanVien={record.id} onSelect={onSelectAccount} select={accountSelected} />,
                                    onExpand: (expand, event) => {
                                        if (expand) {
                                            setExpandedRowKey(event.key);
                                        } else {
                                            setExpandedRowKey("");
                                        }
                                    },
                                    expandedRowKeys: [expandedRowKey]
                                }}
                            >
                                <Column title="Mã nhân viên" dataIndex="ma" key="ma" />
                                <Column title="Tên nhân viên" dataIndex="hoTen" key="hoTen" />
                                <Column title="Phòng ban" dataIndex="tenDonVi" key="tenDonVi" />
                                <Column title="Chức vụ" dataIndex="tenChucVu" key="tenChucVu" />
                            </Table>
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    );
}

export default SearchAccountTable;